import { Component, OnInit, Input, Output, HostListener } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { ApiConnectionService } from 'src/app/services/core/api-connection.service';
import { ConfigService } from 'src/app/services/core/config.service';

import { Title } from '@angular/platform-browser';

@Component({
	selector: 'app-modal-pdf',
	templateUrl: './modal-pdf.component.html',
	styleUrls: ['./modal-pdf.component.scss']
})
export class ModalPdfComponent implements OnInit {
	@Input() public title;
	@Input() public button;
	@Input() public message;
	@Input() public chapterLesson;
	@Output() passEntry: EventEmitter<any> = new EventEmitter();

	baseUrl = '';
	showIframe = false;
	iframeSrc: SafeResourceUrl;

	currentStudentId = '';
	showContent = true;
	showPictures = true;
	showAssignments = true;
	showAssignmentLines = true;

	showTerms = true;
	showDefinitions = true;
	showDefinitionLines = true;

	titleBackup;

	constructor(
		public activeModal: NgbActiveModal,
		private ngxLoader: NgxUiLoaderService,
		public apiConnectionService: ApiConnectionService,
		private configService: ConfigService,
		public sanitizer: DomSanitizer,
		public titleDom: Title
	) {
		this.baseUrl = configService.get('front_url');
	}

	cleanText(input) {
		// Convert to lowercase
		let cleanedText = input.toLowerCase();

		// Remove numbering like '1.', '5.', etc.
		cleanedText = cleanedText.replace(/^\d+\.\s*/, '');

		// Remove special characters (keeping hyphens and spaces for now)
		cleanedText = cleanedText.replace(/[^\w\s-]/g, '');

		// Replace spaces with hyphens
		cleanedText = cleanedText.replace(/\s+/g, '_');

		// Remove any leading or trailing hyphens
		cleanedText = cleanedText.replace(/^-+|-+$/g, '');

		return cleanedText;
	}

	ngOnInit(): void {
	}

	@HostListener('window:keyup.esc', ['$event'])
	onKeyUp(event: KeyboardEvent) {
		this.close();
	}

	confirm() {
		let self = this

		self.button = false

		let result = ({
			showContent: this.showContent,
			showPictures: this.showPictures,
			showAssignmentLines: this.showAssignmentLines,
			showAssignments: this.showAssignments,
			showTerms: this.showTerms,
			showDefinitions: this.showDefinitions,
			showDefinitionLines: this.showDefinitionLines
		});

		let download = '';
		for (let key in result) {
			if (result[key] == true) {
				download += '&' + key + '=1';
			} else {
				download += '&' + key + '=0';
			}
		}

		let studentId = '';
		if (this.currentStudentId !== '') {
			studentId = '/' + self.currentStudentId + '';
		}

		self.ngxLoader.start();

		this.apiConnectionService.read('chapterLessons/requestDownload/' + self.chapterLesson['id'] + '' + studentId + '' + download).then((response) => {
			this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(self.baseUrl + 'print.php?hash=' + response['hash'] + '' + download)
			self.showIframe = true

			self.ngxLoader.stop();

			self.titleBackup = self.titleDom.getTitle();

			const chapterData = this.chapterLesson.chapter;
			const lessonData = this.chapterLesson.lesson;
			self.titleDom.setTitle(this.cleanText(lessonData.name) + "-" + this.cleanText(chapterData.sectionName) + "-" + this.cleanText(lessonData.studyLevel));
		});
	}

	cancel() {
		this.activeModal.close(false);
	}

	close() {
		this.titleDom.setTitle(this.titleBackup);
		this.activeModal.close(false);
	}
}